var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-roles"},[_c('customer-role-list'),_c('customer-relation-list',{attrs:{"full":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }